import { LegoBaseComponent } from '../lego-base.component';

export abstract class LegoBasePopupComponent extends LegoBaseComponent {
}
